module.exports = __webpack_public_path__ + "img/film-poster-placeholder.d1b4253f.png";